import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Tab from 'components/application/Tab';

export default function Tabs({
  activeTab,
  children,
  modifiers = [],
  navClassName,
  onTabClick,
}) {
  const childrenArray = React.Children.toArray(children);
  const tabIds = childrenArray.map((child) => child.props.id);
  const effectiveTab = tabIds.includes(activeTab) ? activeTab : tabIds[0];

  return (
    <div
      className={classNames(
        'tabs',
        modifiers.map((modifier) => `tabs--${modifier}`).join(' '),
      )}
    >
      <ol className={classNames('tabs__nav', navClassName)}>
        {childrenArray.map((child) => {
          const { disabled, flag, icon, id, label, tooltipText } = child.props;

          return (
            <Tab
              activeTab={effectiveTab}
              disabled={disabled}
              flag={flag}
              icon={icon}
              id={id}
              key={id}
              label={label}
              onTabClick={onTabClick}
              tooltipText={tooltipText}
            />
          );
        })}
      </ol>
      <div className='tabs__content'>
        {childrenArray.find((child) => child.props.id === effectiveTab)}
      </div>
    </div>
  );
}

Tabs.propTypes = {
  activeTab: PropTypes.string,
  children: PropTypes.node,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  navClassName: PropTypes.string,
  onTabClick: PropTypes.func,
};
